import { sendPost } from 'helpers/axios';

export const apiDeleteOrderInJob = (params) => sendPost(`api/orders-hr/remove-job`, params);
export const apiDeleteCandidateInJob = (params) => sendPost(`api/job/remove-candidate`, params);

